(() => {
  const storage = {
    get(key) { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch { return null; } },
    set(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch {} },
    pending(key, value) { try { if (value === undefined) return Number(sessionStorage.getItem(key) || 0); value ? sessionStorage.setItem(key, String(value)) : sessionStorage.removeItem(key); } catch {} return 0; }
  };
  function mount(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const dialog = root.querySelector('dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const campaign = root.dataset.campaign;
    const key = `zenraw:welcome:${campaign}`;
    const pendingKey = `${key}:pending`;
    const form = root.querySelector('form');
    const fields = root.querySelector('[data-welcome-fields]');
    const intro = root.querySelector('[data-welcome-intro]');
    const receipt = root.querySelector('[data-welcome-receipt]');
    const submit = root.querySelector('[data-welcome-submit]');
    const submitLabel = submit.innerHTML;
    const editor = root.dataset.editor === 'true';
    const enabled = root.dataset.enabled === 'true';
    let previousFocus;
    let closedHere = false;
    let completed = Boolean(storage.get(key)?.claimed);
    let submitTimer;
    let autoTimer;
    let captchaActive = false;
    let captchaObserver;
    function showReceipt() { fields.hidden = true; intro.hidden = true; receipt.hidden = false; dialog.setAttribute('aria-labelledby', receipt.querySelector('h2').id ||= `${dialog.id}-success`); dialog.removeAttribute('aria-describedby'); }
    function open(manual = false) {
      if (dialog.open || (!enabled && !editor)) return;
      if (!manual && (document.querySelector('[data-crystal-quiz]') || closedHere || document.querySelector('dialog[open]'))) return;
      previousFocus = document.activeElement;
      if (completed) showReceipt();
      dialog.showModal();
      document.documentElement.classList.add('welcome-is-open');
      if (completed) receipt.focus({preventScroll:true});
    }
    function close() {
      if (!dialog.open) return;
      closedHere = true;
      if (!editor) storage.set(key, {claimed:completed, until:Date.now() + (completed ? 365 : Number(root.dataset.dismissDays) || 7) * 86400000});
      dialog.close();
    }
    function release() { document.documentElement.classList.remove('welcome-is-open'); if (!captchaActive && previousFocus?.isConnected) previousFocus.focus({preventScroll:true}); }
    root.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', close));
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
    dialog.addEventListener('close', release);
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } });
    document.querySelectorAll('[data-open-welcome]').forEach(button => { button.hidden = !enabled; if (!button.dataset.bound) { button.dataset.bound = 'true'; button.addEventListener('click', () => document.querySelector('[data-welcome-root]')?.dispatchEvent(new CustomEvent('welcome:open'))); } });
    root.addEventListener('welcome:open', () => open(true));
    function resetSubmit() { clearTimeout(submitTimer); submit.disabled = false; submit.innerHTML = submitLabel; form.removeAttribute('aria-busy'); }
    function watchCaptcha() {
      if (captchaObserver) return;
      // A native dialog occupies the top layer. Yield it when Shopify displays a
      // separate challenge so the platform's verification stays visible and usable.
      const syncChallenge = () => {
        const visible = [...document.querySelectorAll('iframe[title="hCaptcha challenge"]')].some(frame => {
          const rect = frame.getBoundingClientRect();
          return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && getComputedStyle(frame).visibility === 'visible';
        });
        if (visible && !captchaActive) { captchaActive = true; if (dialog.open) dialog.close(); }
        else if (!visible && captchaActive) { captchaActive = false; resetSubmit(); open(true); }
      };
      captchaObserver = new MutationObserver(syncChallenge);
      captchaObserver.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['style','hidden']});
      syncChallenge();
    }
    form.addEventListener('submit', () => {
      watchCaptcha();
      storage.pending(pendingKey, Date.now());
      // Leave the native submitter enabled: Shopify CAPTCHA may replay its click.
      // Busy feedback must not interfere with that platform-controlled submission.
      submit.textContent = submit.dataset.pendingLabel;
      form.setAttribute('aria-busy', 'true');
      submitTimer = setTimeout(resetSubmit, 15000);
    });
    window.addEventListener('pageshow', resetSubmit);
    const posted = root.querySelector('[data-welcome-posted]');
    const ownReturn = location.hash === `#${form.id}` || (storage.pending(pendingKey) > Date.now() - 900000);
    if (posted && ownReturn) {
      completed = true;
      storage.pending(pendingKey, 0);
      if (!editor) storage.set(key, {claimed:true, until:Date.now() + 365 * 86400000});
      showReceipt();
      open(true);
      // Consume only this form's success URL so a refresh does not reopen the receipt.
      const returnUrl = new URL(location.href);
      ['customer_posted', 'contact_posted', 'preview_submitted'].forEach(name => returnUrl.searchParams.delete(name));
      if (returnUrl.hash === `#${form.id}`) returnUrl.hash = '';
      history.replaceState(history.state, '', returnUrl);
    } else if (root.querySelector('[data-welcome-error]') && ownReturn) {
      storage.pending(pendingKey, 0);
      open(true);
    } else if (!editor && enabled && !completed && root.dataset.knownCustomer !== 'true' && !(storage.get(key)?.until > Date.now())) {
      autoTimer = setTimeout(() => open(), Math.max(0, Number(root.dataset.delay) || 0) * 1000);
    }
    root.querySelector('[data-welcome-copy]').addEventListener('click', async event => {
      const button = event.currentTarget;
      const status = root.querySelector('[data-welcome-copy-status]');
      try {
        await navigator.clipboard.writeText(root.querySelector('[data-welcome-code]').textContent.trim());
        button.textContent = button.dataset.copiedLabel;
        status.textContent = button.dataset.copiedLabel;
        setTimeout(() => { button.textContent = button.dataset.copyLabel; }, 2500);
      } catch { status.textContent = status.dataset.fallback; }
    });
    const section = root.closest('.shopify-section');
    section?.addEventListener('shopify:section:select', () => open(true));
    section?.addEventListener('shopify:section:deselect', () => { if (dialog.open) dialog.close(); });
    section?.addEventListener('shopify:section:unload', () => { release(); clearTimeout(submitTimer); clearTimeout(autoTimer); captchaObserver?.disconnect(); window.removeEventListener('pageshow', resetSubmit); });
  }
  document.querySelectorAll('[data-welcome-root]').forEach(mount);
  if (!window.zenrawWelcomeListener) {
    window.zenrawWelcomeListener = true;
    document.addEventListener('shopify:section:load', event => mount(event.target.querySelector('[data-welcome-root]')));
  }
})();
